<template>
  <div>
    <edu-offline-write :form="form" :$v="$v" :isCalender="isCalender" :eduType="eduType" @eventView="fnView" :showSchedule="showSchedule" :schedule="schedule"
                      @eventAddress="fnAddress" @save="fnSubmit" @license="fnLicense" @bindData="fnBindLicense" @location="fnLocation" @education="fnEducation"
                      @selected="fnSelected"/>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import EduOfflineWrite from '@/components/pages/edu/offline/apply/write'
export default {
  name: 'edu-offline-apply-index',
  components: {EduOfflineWrite},
  data() {
    return {
      isCalender: false,
      form: {
        isOver: true,
        offlineEducationNo: -1,
        applyEduNo: -1,
        educationCodeNo: -1,
        userName: '',
        birth: '',
        positionType: 1,
        userPhone: '',
        businessName: '',
        representative: '',
        location: '',
        postCode: '',
        address: '',
        address2: '',
        licenseNumber: '',
        isNew: '',
        sceneNo: '' // 집합 일정 교육 선택 값
      },
      schedule: {
        list: {
          sceneNo: -1,
          eduDate: '',
          time: '',
          address: '',
          personnel: '',
          location: ''
        },
        edu: {
          eduDate: '',
          startTime: ''
        }
      },
      showSchedule: false,
      changeZipProvinceNo: -1
    }
  },
  async created() {
    // 현재 로그인 되어있느 회원정보 바인딩 (이름, 생년월일, 휴대폰번호)
    const res = await this.$UserSvc.fetchUser()
    this.form.userName = res.entity.name
    this.form.birth = res.entity.birth
    this.form.userPhone = res.entity.userPhone
  },
  computed: {
    eduType: function () {
      return this.$store.getters['education/getEduType']
    }
  },
  validations: {
    form: {
      userName: {
        required
      },
      birth: {
        required
      },
      positionType: {
        required
      },
      userPhone: {
        required
      },
      businessName: {
        required
      },
      representative: {
        required
      },
      location: {
        required
      },
      address: {
        required
      },
      licenseNumber: {
        test: function (val) {
          if (this.eduType.salesType === 2) {
            if (this.$Util.isEmpty(val)) return false
          }
          return true
        }
      },
      sceneNo: {
        test: function (val) {
          if (val > 0) {
            return true
          } else {
            return false
          }
        }
      }
    }
  },
  watch: {
    'form.location': async function (val) {
      if (val !== this.changeZipProvinceNo) {
        this.schedule.list.sceneNo = -1
        this.schedule.list.time = ''
        this.schedule.list.address = ''
        this.schedule.list.personnel = 0
        this.schedule.list.location = ''
        this.schedule.edu.eduDate = ''
        this.schedule.edu.startTime = ''
      }
      await this.fnLocation()
      await this.fnEducation()
    },
    'eduType.industryType': async function (){
      // 홈페이지 유지보수 개발요청안 | 업종 분류 변경 시, 영업정보 초기화 추가 (서남아이에스 임현아, 2024-07-09)
      this.form.licenseNumber = ''
      this.form.businessName = ''
      this.form.representative = ''
      this.form.postCode = ''
      this.form.address = ''
      this.form.address2 = ''
      this.form.location = ''
    }
  },
  methods: {
    fnSubmit: async function () {
      this.form.isOver = true
      this.$v.$touch()
      if (!this.$Util.isValid(this.$v, this.$el)) return false
      if (this.form.positionType === 1) {
        if (this.form.userName !== this.form.representative) {
          alert('교육 이수자 이름과 대표자 이름이 일치하지 않습니다.')
          return false
        }
      }
      if (this.form.positionType === 2) {
        if (this.form.userName === this.form.representative) {
          alert('교육 이수자 성명과 대표자 성명이 달라야 합니다.\n다시 확인하시고 입력하여 주십시오.')
          return false
        }
      }
      this.form.salesType = this.eduType.salesType
      this.form.industryType = this.eduType.industryType
      this.form.offlineEduNo = -1
      this.form.isOver = false
      console.log('this.form', this.form)
      const res = await this.$OfflineEduSvc.upsertOfflineEdu(this.form)
      if (res.code === 1) {
        // 홈페이지 유지보수 개발요청안 | 결제내역 => 신청내역 명칭 변경 (서남아이에스 임현아, 2024-07-04)
        // alert('신청서 접수가 완료되었습니다.\n결제내역에서 결제하기 버튼을 눌러 위생교육 결제를 진행해주세요.')
        alert('신청서 접수가 완료되었습니다.\n신청내역에서 결제하기 버튼을 눌러 위생교육 결제를 진행해주세요.')
        this.$store.commit('education/setEduType', {
          eduData: {
            salesType: this.eduType.salesType, industryType: this.eduType.industryType,
            onlineType: this.eduType.onlineType, optionType: this.eduType.optionType, tabType: 2
          }
        })
        await this.$router.push({path: '/edu/offline/list'})
        this.form.isOver = true
        // this.$router.go(-1)
      } else {
        alert(res.message)
        this.form.isOver = true
        // this.$Util.toastAlert(this, res.message, 'danger')
      }
    },
    fnAddress: function () {
      this.$store.commit('layout/setModalAlert', {
        modalAlertName: this.$modalAlertNames.DAUMPOSTCODE,
        isHideHeader: false,
        callBack: this.fnBindDate
      })
    },
    fnBindDate: function ({roadAddress, zonecode}) {
      this.form.address = roadAddress
      this.form.postCode = zonecode
    },
    fnLocation: function () {
      this.showSchedule = true
      const params = {}
      params.salesType = this.eduType.salesType
      params.industryType = this.eduType.industryType
      params.zipProvinceNo = this.form.location
      params.isView = 1
      this.$OfflineEduSvc.fetchLocation(params).then(res => {
        if (res.code === 1) {
          this.isCalender = true
          // this.schedule = res.entity
        } else {
          this.isCalender = false
        }
      })
    },
    fnView: function () {
      this.$router.push({
        // path: '/news/notice/view?noticeNo=78'
        path: '/info/notice/view?noticeNo=136'
      })
    },
    fnSelected: function (item) {
      this.form.offlineEducationNo = item.edu.offlineEducationNo
      this.form.sceneNo = item.list.sceneNo
    },
    fnLicense: function () {
      this.$store.commit('layout/setModal', {
        modalName: this.$modalNames.LICENSE,
        data: {industryType: this.eduType.industryType},
        callBack: this.fnBindLicense
      })
    },
    fnBindLicense: function (item) {
      this.form.licenseNumber = item.lcns_no
      this.form.businessName = item.bssh_nm
      this.form.representative = item.prsdnt_nm
      this.form.postCode = item.zipno
      this.form.address = item.site_addr_juso
      this.form.address2 = item.site_addr_dtl
    },
    fnEducation: function () {
      this.$store.commit('layout/setModal', {
        modalName: this.$modalNames.CALENDER,
        data: {
          industryType: this.eduType.industryType,
          salesType: this.eduType.salesType,
          zipProvinceNo: this.form.location,
          isModify: false
        },
        callBack: this.fnBindEdu
      })
    },
    fnBindEdu: function (item, emitType) {
      if (emitType !== 'close') {
        this.changeZipProvinceNo = item.edu.zipProvinceNo;
        if (this.form.location !== item.edu.zipProvinceNo) {
          this.form.location = item.edu.zipProvinceNo
        }
        this.form.sceneNo = item.list.sceneNo
        this.form.offlineEducationNo = item.edu.offlineEducationNo
        this.schedule.list.sceneNo = item.list.sceneNo
        this.schedule.list.time = item.list.endTime
        this.schedule.list.address = item.list.address
        this.schedule.list.personnel = item.list.personnel
        this.schedule.list.location = item.list.location
        this.schedule.edu.eduDate = item.edu.eduDate
        this.schedule.edu.startTime = item.edu.startTime
        this.schedule.count = item.count
      }
    }
  }
}
</script>

<style scoped>

</style>
